import React from 'react';
import { ColorRing, Grid } from 'react-loader-spinner';
import './Loader.css';

const Loader = () => {
  return (
    <div className="loader-overlay">
      <Grid
        visible={true}
        height="50"
        width="50"
        colors={['#b1000e', '#000', '#b1000e', '#000', '#b1000e', '#000']}
        ariaLabel="grid-loading"
        radius="12.5"
        wrapperStyle={{}}
        wrapperClass="grid-wrapper"
      />
    {/* <ColorRing
        visible={true}
        height="60"
        width="60"
        ariaLabel="color-ring-loading"
        wrapperStyle={{}}
        wrapperClass="color-ring-wrapper"
        colors={['#b1000e', '#000', '#b1000e', '#000', '#b1000e', '#000']}
  /> */}
    </div>
  );
};

export default Loader;
